export default "__VITE_ASSET__CjQEgAGc__"